// Ported from WOOF1_eCRF_v7.html (source line 4040, getSectionsForVisit).
// Render functions are frontend-only; here we keep just the section id/label/icon
// list per visit key, used by the clinical-data service for validation/shape and
// by the frontend for tab rendering.
export interface SectionDef {
  id: string;
  label: string;
  icon: string;
}

const S = {
  eligibility: { id: "eligibility", label: "Éligibilité", icon: "✅" },
  vital: { id: "vital", label: "Signes vitaux", icon: "🩺" },
  physical: { id: "physical", label: "Examen physique", icon: "🔍" },
  caliper: { id: "caliper", label: "Mesures caliper", icon: "📏" },
  ctscan: { id: "ctscan", label: "CT scan", icon: "🔬" },
  tnm: { id: "tnm", label: "TNM / Stade", icon: "📊" },
  biopsy: { id: "biopsy", label: "Biopsie", icon: "🧪" },
  metastasis: { id: "metastasis", label: "Métastases", icon: "🔴" },
  past_tx: { id: "past_tx", label: "Traitements antérieurs", icon: "📋" },
  blood: { id: "blood", label: "Bilan sanguin", icon: "🩸" },
  cytokines: { id: "cytokines", label: "Cytokines", icon: "🧬" },
  corq: { id: "corq", label: "CORQ", icon: "🐕" },
  mh: { id: "mh", label: "Antécédents médicaux", icon: "📜" },
  cm: { id: "cm", label: "Traitements concomitants", icon: "💊" },
  inclusion: { id: "inclusion", label: "Décision d'inclusion", icon: "📜" },
  drug_admin: { id: "drug_admin", label: "Administration F1901", icon: "💉" },
  irecist: { id: "irecist", label: "iRECIST", icon: "📈" },
  ae: { id: "ae", label: "Événements indésirables", icon: "⚠️" },
} satisfies Record<string, SectionDef>;

export function getSectionsForVisit(vk: string): SectionDef[] {
  const isExtra = /^V[1-9][0-9]+$/.test(vk);

  if (vk === "V0") {
    return [
      S.eligibility, S.vital, S.physical, S.caliper, S.ctscan, S.tnm,
      S.biopsy, S.metastasis, S.past_tx, S.blood, S.corq, S.mh, S.cm, S.inclusion,
    ];
  }
  if (vk === "V1") {
    return [S.vital, S.physical, S.caliper, S.drug_admin, S.blood, S.cytokines, S.corq, S.irecist, S.cm, S.ae];
  }
  if (vk === "V1b") {
    return [S.vital, S.physical, S.cm, S.ae];
  }
  if (vk === "V2" || vk === "V3") {
    return [S.vital, S.physical, S.caliper, S.blood, S.cytokines, S.corq, S.cm, S.ae];
  }
  if (vk === "V4") {
    return [S.vital, S.physical, S.caliper, S.ctscan, S.drug_admin, S.blood, S.corq, S.irecist, S.cm, S.ae];
  }
  if (vk === "V5" || vk === "V7" || vk === "V8") {
    return [S.vital, S.physical, S.caliper, S.blood, S.corq, S.cm, S.ae];
  }
  if (vk === "V6") {
    return [S.vital, S.physical, S.caliper, S.ctscan, S.drug_admin, S.blood, S.corq, S.irecist, S.cm, S.ae];
  }
  if (vk === "V9" || isExtra) {
    return [S.vital, S.physical, S.caliper, S.ctscan, S.blood, S.corq, S.irecist, S.cm, S.ae];
  }
  // Fallback générique
  return [S.vital, S.physical, S.blood, S.cm];
}

// EoS is a single-form visit, not rendered via getSectionsForVisit (source: renderVisitContent line 4381).
export const EOS_SECTION: SectionDef = { id: "eos", label: "Fin d'étude", icon: "🏁" };

export const ALL_SECTION_IDS = Object.keys(S);
